import { render, staticRenderFns } from "./WeRecommend.vue?vue&type=template&id=5ab1b561&"
import script from "./WeRecommend.vue?vue&type=script&lang=js&"
export * from "./WeRecommend.vue?vue&type=script&lang=js&"
import style0 from "./WeRecommend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports